import React from "react";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import AddItems from "../Registration/Items/addItems";
import AltItems from "../Registration/Items/altItems";
import BottomBar from "../../Components/bottomBar/bottomBar";
import "./prelude.css";
import Api from "../../services/api";
import TableList from "../../Components/tableList/TableList";
import Alert from "../../Components/alert/Alert";
import MessageTable from "../../Components/messageTable/MessageTable";
import TopBar from "../../Components/topBar/topBar";
import {handleColor} from '../../services/Functions'
import ReportItems from "../Reports/reportItems";

const prelude_items = () => {
  return (
    <>
     <header>
        <TopBar/>
     </header> 
      <main className="prelude_container">
        <Sidebar/>
      </main>   
      <BottomBar></BottomBar>  
    </>
  );
};

class Sidebar extends React.Component {
  state = {
    data: [],
    keys: [],
    render: false,
    message: "",
    click: false,
    controller: "",
    id: "",
    redirect: false,
    operations:[]
  };

  async componentDidMount() {
    let array  = [];
    let array1 = [];
    await Api.get("/items")
      .then((response) => {
        response.data.forEach((element) => {
          array.push({
            Código: element.code,
            descrição: element.description
          });
        });
        if (array.length > 0) this.setState({ data: array,operations:array1, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
     /*  let viewport = document.querySelector("meta[name=viewport]");
      viewport.setAttribute("content", viewport.content + ", height=" + window.innerHeight); */
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { show, message } = this.state;
    return (
      <Tab.Container defaultActiveKey="list">
        <Row style={{width:'100%',height:'100%'}}>
         <div className="sidebar1">
            <div className="sidebar2">
              <Col className="sidebarColumn">
                <ListGroup>
                  <ListGroup.Item
                    id="lg1"
                    style={{
                      backgroundColor: "#05ca83",
                      color: "#fff",
                      border: "none",
                    }}
                    onClick={handleColor}
                    className="listGroup"
                    eventKey="list"
                  >
                    Itens
                  </ListGroup.Item>
                  <ListGroup.Item
                    id="lg2"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="add"
                  >
                    Adicionar Item
                  </ListGroup.Item>
                  <ListGroup.Item
                    id="lg3"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="alt"
                  >
                    Alterar/excluir Item
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </div>
            <Col className='col3' style={{ top: "2%", marginLeft: "1%", width: "100%",height:'96%', overflow:'hidden' }}>
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content style={{height:'100%' }}>
                <Tab.Pane style={{height:'100%' }} eventKey="list">
                  {this.handleClick ? <ReportItems /> : null}
                </Tab.Pane>
                <Tab.Pane style={{height:'100%', overflow: "scroll", overflowX: "hidden" }}  eventKey="add">
                  {this.handleClick ? <AddItems /> : null}
                </Tab.Pane>
                <Tab.Pane className="display" style={{height:'100%', overflow: "scroll", overflowX: "hidden" }}  eventKey="alt">
                  {this.handleClick ? <AltItems /> : null}
                </Tab.Pane>
              </Tab.Content>
              </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_items;